<template>
  <Toast />
  <Message v-if="!service_enabled" severity="warn">Mail service is disabled for this domain</Message>
  <Breadcrumb :home="bc_home" :model="bc_items" />
  <MailNavBar />
  
  <Card v-if="MailAliases" class="">
      <template #title>
        <Button icon="pi pi-plus" class="p-button-rounded p-button-primary" @click="openNewAliasModal" />
      </template>
        <template #content>
          
            <DataTable :value="MailAliases.aliases" class="p-datatable-sm" responsiveLayout="stack" @row-click="openAliasModal($event)" rowHover stripedRows selectionMode="single">
                <template #empty>
                  <div style="text-align: center;">No aliases found</div>
                </template>
                <Column field="alias" header="Alias"></Column>
                <Column field="destination" header="Destination"></Column>
                <Column header="Active" headerStyle="width: 100px; text-align: right">
                  <template #body="slotProps">
                    <i v-if="slotProps.data.is_enabled" style="color:var(--green-400)" class="pi pi-check-circle"></i>
                    <i v-else style="color:var(--orange-400)" class="pi pi-minus-circle"></i>
                  </template>
                </Column>
            </DataTable>
        </template>
  </Card>
  
  <Dialog header="New Alias" v-model:visible="displayNewAliasModal" :modal="true">
      <div class="new-alias">
          <form class="p-fluid" v-on:submit.prevent>
              <div class="p-field">
                  <div class="p-float-label">
                      <InputText id="alias" v-model="alias.alias" autofocus />
                      <label for="alias">Alias *</label>
                      <small class="p-error" v-if="errors.alias">{{ errors.alias }}</small>
                  </div>
              </div>
              <div class="p-field">
                  <div class="p-float-label">
                      <InputText id="destination" v-model="alias.destination" v-on:keyup.enter="createAlias" />
                      <label for="destination">Destination *</label>
                      <small class="p-error" v-if="errors.destination">{{ errors.destination }}</small>
                  </div>
              </div>
              <div class="p-field-checkbox">
                  <Checkbox id="is_enabled" :binary="true" v-model="alias.is_enabled"></Checkbox>
                  <label for="is_enabled">Enabled</label>
              </div>
              
          </form>
      </div>
      <template #footer>
        <Button label="Create" icon="pi pi-check-square" class="w-full" :loading="loading" @click="createAlias"></Button>
      </template>
  </Dialog>
  <Dialog :header="alias.alias" v-model:visible="displayAliasModal" :modal="true">
      <div class="new-alias">
          <form class="p-fluid" v-on:submit.prevent>
              <div class="p-field">
                  <div class="p-float-label">
                      <InputText id="alias" v-model="alias.alias" v-on:keyup.enter="saveAlias"/>
                      <label for="alias">Alias</label>
                      <small class="p-error" v-if="errors.alias">{{ errors.alias }}</small>
                  </div>
              </div>
              <div class="p-field">
                  <div class="p-float-label">
                      <InputText id="destination" v-model="alias.destination" v-on:keyup.enter="saveAlias"/>
                      <label for="destination">Destination *</label>
                      <small class="p-error" v-if="errors.destination">{{ errors.destination }}</small>
                  </div>
              </div>
              <div class="p-field-checkbox">
                  <Checkbox id="is_enabled" :binary="true" v-model="alias.is_enabled"></Checkbox>
                  <label for="is_enabled">Enabled</label>
              </div>
          </form>
      </div>
      <template #footer>
          <Button label="Delete" class="p-button-text p-button-danger" @click="deleteAlias(alias)"></Button>
          <Button label="Update" icon="pi pi-check-square" :loading="loading" @click="saveAlias"></Button>
      </template>
  </Dialog>
  <ConfirmDialog></ConfirmDialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { getAttributes } from "../helpers/attributes.js"
import { convertErrors } from "../helpers/errors.js"
import MailNavBar from '../components/MailNavBar.vue'

export default {
  name: 'MailAliases',
  components: {
    MailNavBar
  },
  data () {
    return {
      alias: {
        id: '',
        alias: '',
        destination: '',
        is_enabled: true
      },
      domain_name: 'test_domain',
      errors: {},
      displayAliasModal: false,
      displayNewAliasModal: false,
      domains: [],
      selectedDomain: null,
      loading: false,
      bc_home: {icon: 'pi pi-home', to: '/domains'},
      bc_items: [
          {icon: 'pi pi-spin pi-spinner'},
          {label: 'Mail', to: '/domains/'+this.$route.params.domain_id+'/mail'},
          {label: 'Aliases'}
      ],
      service_enabled: true,
    }
  },
  created: function () {
    this.GetMailAliases(this.$route.params.domain_id)
  },
  computed: {
    ...mapGetters({ MailAliases: 'StateMailAliases', Domains: 'StateDomains' }),
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    current_domain() {
      return this.MailAliases
    }
  },
  watch: {
    current_domain (d) {
      if (d.domain && d.domain.name.length) {
        this.domain_name = d.domain.name
        this.bc_items = [
          {label: d.domain.name, to: '/domains/'+this.$route.params.domain_id},
          {label: 'Mail', to: '/domains/'+this.$route.params.domain_id+'/mail'},
          {label: 'Aliases'}
        ]

        const services = getAttributes(d.domain.attributes, 'services')

        if (services && services.mail && services.mail.enabled) {
          this.service_enabled = true
        }
        else {
          this.service_enabled = false 
        }
      }
    },
  },
  methods: {
    ...mapActions(['CreateMailAlias', 'GetMailAliases', 'UpdateMailAlias', 'DeleteMailAlias', 'GetDomains', 'GetDomainById']),
    async createAlias () {
      this.loading = true
      this.errors = {}
      
      this.alias.domain_id = this.$route.params.domain_id

      this.CreateMailAlias(this.alias)
        .then(response => {
          this.displayNewAliasModal = false
          this.alias = {id: '', alias: '', destination: '', is_enabled: true}
          this.$toast.add({severity:'success', summary: 'Alias created', detail:response.data.address, life: 3000});
        })
        .catch(error => {
          this.errors = convertErrors(error.response.data)
          console.log(this.errors)
        })
        .finally(() => this.loading = false)
    },
    async saveAlias () {
      this.loading = true
      this.errors = {}
      
      this.UpdateMailAlias(this.alias)
        .then(response => {
          this.displayAliasModal = false
          this.alias = {id: '', alias: '', destination: '', is_enabled: true}
          this.$toast.add({severity:'success', summary: 'Alias updated', detail:response.data.address, life: 3000});
        })
        .catch(error => {
          this.errors = convertErrors(error.response.data)
        })
        .finally(() => this.loading = false)
    },
    async deleteAlias(alias) {
      this.errors = {}
      
      this.$confirm.require({
          message: 'Are you sure you want to delete ' + alias.alias + '?',
          header: 'Confirmation',
          icon: 'pi pi-exclamation-triangle',
          acceptClass: 'p-button-danger',
          accept: () => {
            this.loading = true

            this.DeleteMailAlias(alias)
              .then(response => {
                this.displayAliasModal = false
                this.$toast.add({severity:'info', summary: 'Alias deleted', life: 3000});
              })
              .catch(error => {
                this.errors = error.response.data.errors
              })
              .finally(() => this.loading = false)
          },
          reject: () => {
              //callback to execute when user rejects the action
          }
      });


    },
    openNewAliasModal() {
      this.alias = {id: '', alias: '', destination: '', is_enabled: true}
      this.errors = {}
      this.displayNewAliasModal = true
    },
    openAliasModal(e) {
      this.errors = {}
      const result = this.MailAliases.aliases.find( ({ id }) => id === e.data.id );
      Object.assign(this.alias, result)
      this.displayAliasModal = true
    }
  }
}
</script>

<style lang="scss" scoped>
.new-alias {
        form {
            margin-top: 2rem;
        }

        .p-field {
            margin-bottom: 1.5rem;
        }


}
</style>